import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
export var AbstractFeatureLoader =
/*#__PURE__*/
function () {
  function AbstractFeatureLoader() {
    _classCallCheck(this, AbstractFeatureLoader);

    _defineProperty(this, "isSetup", void 0);

    _defineProperty(this, "isFailure", void 0);
  }

  _createClass(AbstractFeatureLoader, [{
    key: "isFeatureEnabled",
    value: function isFeatureEnabled(name) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getFeature(name, context, options).enabled;
    }
  }, {
    key: "getFeatures",
    value: function getFeatures(names) {
      var _this = this;

      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return names.map(function (name) {
        return _this.getFeature(name, context);
      });
    }
  }]);

  return AbstractFeatureLoader;
}();